module.exports = __webpack_public_path__ + "img/red_043.aba0c0bf.png";